import fetch from "./sessionFetch";
import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

function getSettings() {
  return fetch(`${baseUrl}settings`, {
    headers: authHeaders(),
  }).then(handleResponse);
}

function saveSetting(setting) {
  return fetch(`${baseUrl}settings/${setting.id}`, {
    method: "PUT",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(setting),
  }).then(handleResponse);
}

export default {
  getSettings,
  saveSetting,
};
